<template>
    <div class="public_container customer_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter">

            </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <CustomFormMobile
                ref="crm_custom_form"
                :field_list="formInfoList"
                :is_form_module="true"
                @submit-form="submitFormData"
                v-if="dataLoaded"
            />
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import {EventBus} from '@/utils/eventBus';
import {removeTag} from "@/utils";
import { getFormFields, CustomerPublicAdd, CustomerPrivateAdd } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MCustomerAdd",
    components: { ReturnNavBar, CustomFormMobile },
    data() {
        return {
            addType: this.$route.query && this.$route.query.addType, // 新增类型 public：公海，private：私海
            sea_id: this.$route.query && this.$route.query.sea_id, // 公海id
            loading: false,
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
        };
    },
    created() {
        this._getFromFields();
    },
    methods: {
        handleClickReturnRouter() {
            removeTag(this.$route)
            this.$router.go(-1);
        },
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customers",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    this.loading = false;
                    this.dataLoaded = true;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.crm_custom_form.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                this.loading = true
                this.btnDisabled = true
                if (this.addType === "public") {
                    // 公海
                    CustomerPublicAdd({ sea_id: this.sea_id, ...customForm })
                        .then((res) => {
                            this.loading = false
                            this.btnDisabled = false;
                            if (res.code == 200) {
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        removeTag(this.$route);
                                        EventBus.$emit('customerAddUpdated');
                                        this.$router.go(-1);
                                    },
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.btnDisabled = false;
                        });
                } else {
                    CustomerPrivateAdd(customForm)
                        .then((res) => {
                            this.loading = false
                            this.btnDisabled = false;
                            if (res.code == 200) {
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        removeTag(this.$route);
                                        EventBus.$emit('customerAddUpdated');
                                        this.$router.go(-1);
                                    },
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.btnDisabled = false;
                        });
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.customer_add_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
